<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-credit-card"></i>
    <ng-container i18n>Billing Details</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <i [class]="cardLogo"></i>
  <div>
    <table border="0">
      <tr>
        <td align="right" i18n>Name:</td>
        <td>
          &nbsp;&nbsp;<b> {{ data.inquiry.billing.name }} </b>
        </td>
      </tr>
      <tr>
        <td align="right" i18n>Card number:</td>
        <td>
          &nbsp;&nbsp;<b> **** - **** - **** -{{ data.inquiry.billing.last4 }} </b>
        </td>
      </tr>
      <tr>
        <td align="right" i18n>Expires:</td>
        <td>
          &nbsp;&nbsp;<b> {{ data.inquiry.billing.expMonth }} / {{ data.inquiry.billing.expYear }} </b>
        </td>
      </tr>
      <tr>
        <td align="right" i18n>Postal code:</td>
        <td>
          &nbsp;&nbsp;<b> {{ data.inquiry.billing.zip }} </b>
        </td>
      </tr>
      <tr>
        <td align="right" i18n>CVC code:</td>
        <td>
          &nbsp;&nbsp;<b> {{ data.inquiry.billing.cvc }} </b>
        </td>
      </tr>
    </table>
    <br />
    <ng-container i18n>This card is saved in your</ng-container
    ><strong> {{ getGatewayName(data.inquiry.billing.gateway) }} </strong>
    <ng-container i18n>payment gateway</ng-container><strong> {{ data.payment.name || data.payment.pkey }}</strong
    >.
  </div>
</div>
<div class="modal-footer">
  <button (click)="deleteCard()" type="button" class="btn btn-secondary-danger">
    <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>delete</ng-container>
  </button>
  <button (click)="save(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="fal fa-check-square"></i> <ng-container i18n>close</ng-container>
  </button>
</div>
